import { Link } from "react-router-dom";

const LogoIcon = () => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="15" stroke="#1C3829" strokeWidth="1.5" />
    <path
      d="M10 16 C10 11, 16 8, 22 12 C22 17, 16 24, 10 20 C10 18, 12 17, 16 16 C14 14.5, 11 14, 10 16Z"
      fill="#1C3829"
      opacity="0.8"
    />
    <circle cx="20" cy="12" r="2" fill="#1C3829" />
  </svg>
);

export function PublicNav() {
  return (
    <nav className="public-nav">
      <Link to="/" className="nav-logo">
        <LogoIcon />
        Distilled Intuition
      </Link>
      <ul className="nav-links">
        <li><Link to="/#platform-capabilities">Features</Link></li>
        <li><Link to="/#showcase">Solutions</Link></li>
      </ul>
      <div className="nav-actions">
        <Link to="/auth" className="btn-ghost">Sign In</Link>
        <Link to="/request-demo" className="btn-primary">Request Demo</Link>
      </div>
    </nav>
  );
}
